import { AGGREGATION_RULES } from "@/pages/intelligence/components/AggregationBubble/utils/static_data";

export const CHART_COLOR = [
  ['#5086F3', '#69D19C', '#6E7794', '#F5D242', '#7F6FF1', '#5EC8F1', '#AD53D4', '#F19E55', '#488E89', '#F17C86'],
  ['#7DADFF', '#92DEB4', '#949BB3', '#FFE76E', '#AD9EFF', '#8CE2FF', '#C57BE0', '#FFC182', '#70A7A0', '#FFABAF'],
];

const COLOR_ARR = [
  '#5086F3',
  '#77E097',
  '#6A7597',
  '#F8CC6A',
  '#A08FF2',
  '#5EC8F1',
  '#CF61AC',
  '#F19E55',
  '#387F7D',
  '#F17C86',
  '#709FFF',
  '#45AF6A',
  '#9AA5C9',
  '#BE9737',
  '#9C8CEE',
  '#3EAFD7',
  '#E171BD',
  '#CE8038',
  '#6BB1AF',
  '#E5727C',
  '#ABD2FF',
  '#78E198',
  '#CDD8FD',
  '#F3C866',
  '#D4C0FF',
  '#7BE2FF',
  '#FFA7F3',
  '#FBB167',
  '#9EE5E2',
  '#FFAAB3',
  '#D4E8FF',
  '#92FBB0',
  '#E5EBFD',
  '#FFE683',
  '#F1DCFF',
  '#99FEFF',
  '#FFCAFF',
  '#FFD286',
  '#B9FFFE',
  '#FFCAD2',
];


export const FuncNameMap:any = {
  FuncSum: "_总和",
  FuncAvg: "_均值",
  FuncMax: "_最大值",
  FuncMin: "_最小值",
  FuncDistinct: "_去重数",
  FuncCount: "_计数",
  FuncVariance: "_方差",
  FuncStd: "_标准方差",
  FuncAvgpp: "_人均值",
  FuncCusExpress: "自定义表达式",
};

export const aggregateObj:any = {
  "sum": "FuncSum",
  "avg": "FuncAvg",
  "max": "FuncMax",
  "min": "FuncMin",
  "distinct": "FuncDistinct",
  "count": "FuncCount",
  "variance": "FuncVariance",
  "std": "FuncStd",

  "toDate": "FuncToDate",
  "toStartOfWeek": "FuncToWeek",
  "toStartOfMonth": "FuncToMonth",

  "avgpp": "FuncAvgpp",
  "cusExpress": "FuncCusExpress",
};